var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"multivariate-home"}},[_c('PluginHeader',{attrs:{"title":"Multivariate Zoning","subtitle":"K-means clustering across many variables","icon":"fas fa-chart-scatter"}}),_c('AlertMessage'),_c('ChooseDatasets')],1)}
var staticRenderFns = []

export { render, staticRenderFns }